import React from 'react'

const SearchTests: React.FC = () => {
  return (
    <form id="form1" >
    <div>
        <table>
            <tr className='trowT'
            // style={{ verticalAlign: "central" }}
            >
                <td>
                  <select id='ddlQnsSelectionType'>
                    <option>--Select QnSelection type --</option>
                    <option value='0'>Type - 0</option>
                    <option value='1'>Type - 1</option>
                    <option value='2'>Type - 2</option>
                    <option value='3'>Type - 3</option>
                    <option value='4'>Type - 4</option>
                    <option value='5'>Type - 5</option>
                    <option value='6'>Type - 6</option>
                  </select>
                </td>
                <td>
                  <select id='ddlCountry'>
                    <option>Australia</option>
                    <option>Canada</option>
                  </select>
                </td>
                <td>
                    <button id="btnSearch">Search</button>
                </td>
            </tr>
            <tr>
                <td>
                    <label id="lblTests" ></label></td>
            </tr>
        </table>
        <br />
        <div id="divResults" className='divResultsT'
        style={{ width: "100%", height: "auto" }}
        >



        </div>
    </div>
</form>
  )
}

export default SearchTests
